import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SectionBase } from 'pages/conversations/pages/search/ui/Results/ui/SectionBase/SectionBase'
import { useResultsContext } from 'pages/conversations/pages/search/ui/Results/context/resultsContext'
import { ContactCard } from 'pages/conversations/pages/search/ui/Results/ui/ContactCard/ContactCard'
import { logV2SearchEvent } from 'pages/conversations/pages/search/utils/logSearchEvent'

export const SectionContacts = observer(() => {
  const entities = useEntitiesContext()
  const { resultsContactsStore, setActiveTab, handleGoToProfile } = useResultsContext()
  const { itemsTopResult, loadingTopResult, hasItemsTopResult } = resultsContactsStore

  return (
    <SectionBase
      title={'Contacts'}
      loading={loadingTopResult}
      notResult={!hasItemsTopResult}
      notResultTitle={'No contacts found'}
      linkTitle={'View all contacts'}
      onClickLinkTitle={() => {
        setActiveTab('contacts')

        logV2SearchEvent(
          'Search Page Result Clicked',
          {
            event_id: 'search_page_result_clicked',
            SearchResultClickedType: 'View all Contacts',
          },
          entities
        )
      }}
    >
      {itemsTopResult.map((item) => {
        return (
          <ContactCard
            key={item.key}
            item={item}
            onActionClick={(item) => {
              handleGoToProfile(item)

              logV2SearchEvent(
                'Search Page Result Clicked',
                {
                  event_id: 'search_page_result_clicked',
                  SearchResultClickedType: 'Contact_top_results',
                },
                entities
              )
            }}
          />
        )
      })}
    </SectionBase>
  )
})
